require("./aggregatorAddEntityModal.scss");

import React from "react";
import { withRouter } from 'react-router-dom';
import PropTypes from "prop-types";

import { AggregatorAddEntityNewModal } from "./components/aggregatorAddEntityNewConsentsModal/aggregatorAddEntityNewModal";
import { AggregatorAddEntityOldModal } from "./components/aggregatorAddEntityOldModal/aggregatorAddEntityOldModal";

class AggregatorAddEntityModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModal: props.showModal,
        };
    }

    static getDerivedStateFromProps(props) {
        const { immAggregatorAddEntity } = props;

        if (immAggregatorAddEntity.get("termsAndConditions")) {
            return { showModal: false };
        }

        return null;
    }

    handleOnRequestClose = () => {
        this.props.history.push("/myprofile/global");
    };

    handleTermsAndConditionsButton = (modalState) => {
        const { handleTermsAndConditions, newCategorized } = this.props;
        const AGGREGATOR_V2 = newCategorized;

        if (AGGREGATOR_V2) {
            handleTermsAndConditions({ ...modalState });
        } else {
            this.setState({
                showModal: false,
            });
        }
    };

    render() {
        const { immAggregatorAddEntity, newConsents } = this.props;
        const { showModal } = this.state;

        if (newConsents) {
            return (
                <AggregatorAddEntityNewModal
                    showModal={showModal}
                    immAggregatorAddEntity={immAggregatorAddEntity}
                    onHandleTermsAndConditionsButton={this.handleTermsAndConditionsButton}
                    onRequestClose={() => this.handleOnRequestClose()}
                />
            );
        } else {
            return (
                <AggregatorAddEntityOldModal
                    showModal={showModal}
                    immAggregatorAddEntity={immAggregatorAddEntity}
                    onHandleTermsAndConditionsButton={this.handleTermsAndConditionsButton}
                    onRequestClose={() => this.handleOnRequestClose()}
                />
            );
        }
    }
}

AggregatorAddEntityModal.propTypes = {
    showModal: PropTypes.bool,
    newCategorized: PropTypes.bool,
    newConsents: PropTypes.bool,
    handleTermsAndConditions: PropTypes.func,
    immAggregatorAddEntity: PropTypes.object,
    history: PropTypes.object.isRequired,
};

export default withRouter(AggregatorAddEntityModal);
